module.exports = __webpack_public_path__ + "static/media/Thor.518b57b0.jpg";